import parse from "html-react-parser";

const PromoBadge = ({ variant = "target", ctaText, description, styles = {}, onSelect, className = "" }) => {
  const { backgroundColor, ctaColor, textColor } = styles;
  const isClickable = typeof onSelect === "function";

  const handleActivate = (event) => {
    event.stopPropagation();
    onSelect();
  };

  const rootClassName = [
    "productPickerBadge",
    `productPickerBadge--${variant}`,
    ctaText ? "" : "productPickerBadge--noCta",
    isClickable ? "productPickerBadge--clickable" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={rootClassName}
      style={{ backgroundColor }}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={isClickable ? handleActivate : undefined}
      onKeyDown={
        isClickable
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleActivate(event);
              }
            }
          : undefined
      }
    >
      {ctaText && (
        <span className="productPickerBadge__cta" style={{ backgroundColor: ctaColor, color: textColor }}>
          {ctaText}
        </span>
      )}
      <span className="productPickerBadge__text">{parse(description || "")}</span>
    </div>
  );
};

export default PromoBadge;
